import ToastService from '~/services/toast.service';

import { updateByKey } from '@vestigas/utils';
import { log } from '~/utils/logging';

/**
 * Updates the list of filter groups by replacing the selected filter group provided updated filter group object.
 *
 * @param {Array} filterGroups - The array of filter groups to update.
 * @param {string} selectedFilterGroupId - The ID of the selected filter group.
 * @param {object} updatedFilterGroupObject - The updated filter group object.
 * @param {function} setDelivery_filterGroups - Callback function to update the filter groups in the Redux store.
 * @param {function} updateUserSettings - The function to update filter groups on back-end.
 */
export const updateFilterGroup = async (
  dispatch,
  filterGroups,
  selectedFilterGroupId,
  updatedFilterGroupObject,
  setDelivery_filterGroups,
  updateUserSettings,
) => {
  const newFilterGroups = updateByKey(
    filterGroups,
    'id',
    selectedFilterGroupId,
    updatedFilterGroupObject,
  );

  await updateUserSettings(
    { webappDeliveryFilterGroups: newFilterGroups },
    {
      onError(error) {
        log.error({ message: 'Failed to update filter group.', error });
        ToastService.error(['Filter konnte nicht geändert werden.']);
        throw error; // Re-throw error to be caught by calling function
      },
    },
  );

  dispatch(setDelivery_filterGroups(newFilterGroups));
};
